import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class CannedResponsesService {
  private getHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  async list(search?: string) {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    const res = await axios.get(`${API_BASE_URL}/admin/canned-responses${params}`, { headers: this.getHeaders() });
    return res.data.data.docs || [];
  }

  async create(payload: { title: string; content: string; category?: string }) {
    const res = await axios.post(`${API_BASE_URL}/admin/canned-responses`, payload, { headers: this.getHeaders() });
    return res.data.data.doc;
  }

  async update(id: string, payload: { title: string; content: string; category?: string }) {
    const res = await axios.patch(`${API_BASE_URL}/admin/canned-responses/${id}`, payload, { headers: this.getHeaders() });
    return res.data.data.doc;
  }

  async remove(id: string) {
    await axios.delete(`${API_BASE_URL}/admin/canned-responses/${id}`, { headers: this.getHeaders() });
  }
}

export default new CannedResponsesService();


